/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDealerInfo_seller = {
    readonly agreementStart: string | null;
    readonly sellerOrderQuantity: number | null;
    readonly analytics: {
        readonly metrics: {
            readonly responseTime: {
                readonly value: number | null;
            } | null;
        } | null;
    } | null;
    readonly tradeAssociations: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly displayName: string | null;
    } | null> | null;
    readonly liveStorefrontProfile: {
        readonly establishmentYear: string | null;
    } | null;
    readonly " $refType": "PdpSharedDealerInfo_seller";
};
export type PdpSharedDealerInfo_seller$data = PdpSharedDealerInfo_seller;
export type PdpSharedDealerInfo_seller$key = {
    readonly " $data"?: PdpSharedDealerInfo_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDealerInfo_seller">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDealerInfo_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agreementStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sellerOrderQuantity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MCAnalytics",
      "kind": "LinkedField",
      "name": "analytics",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MCAnalyticsMetrics",
          "kind": "LinkedField",
          "name": "metrics",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "MCMetricResponseTime",
              "kind": "LinkedField",
              "name": "responseTime",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeAssociation",
      "kind": "LinkedField",
      "name": "tradeAssociations",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StorefrontProfile",
      "kind": "LinkedField",
      "name": "liveStorefrontProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "establishmentYear",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};
(node as any).hash = '653b085bafe389c053addae877ac0ed9';
export default node;
